import { HStack, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Box, Skeleton } from 'native-base';
import * as RN from 'react-native';

export const rowHeight = 78;

export const columnWidthsTablet = {
  personal: 21,
  document: 13,
  custodyAccount: 16,
  sinacorAccount: 13,
  monthCompetence: 13,
  balanceAvailable: 13,
  rate: 11,
};

export const columnWidthsDesktop = {
  personal: 21,
  document: 13,
  custodyAccount: 16,
  sinacorAccount: 13,
  monthCompetence: 13,
  balanceAvailable: 13,
  rate: 11,
};

export const maxHeight = `${
  RN.Dimensions.get('window').height - RN.Dimensions.get('window').height * 0.37
}px`;

export const maxHeightMobile = `${
  RN.Dimensions.get('window').height > 741
    ? RN.Dimensions.get('window').height - RN.Dimensions.get('window').height * 0.5
    : RN.Dimensions.get('window').height - RN.Dimensions.get('window').height * 0.64
}px`;

export const loadingErrorItemMobile = (
  <VStack
    marginBottom={Spacing['inset.xs']}
    borderRadius={Spacing['inline.nano']}
    width={'100%'}
    justifyContent={'space-between'}
    paddingX={Spacing['inset.sm']}
    paddingY={Spacing['inset.nano']}
    background={Color['neutral.white']}>
    <HStack alignItems={'center'} py={Spacing['inset.nano']}>
      <Skeleton
        borderRadius={'100%'}
        height={'24px'}
        width={'24px'}
        marginRight={Spacing['inset.nano']}
      />
      <Skeleton borderRadius={Spacing['inline.nano']} height={'24px'} width={'60%'} />
    </HStack>
    <Box paddingBottom={Spacing['inline.nano']}>
      <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} width={'26%'} />
    </Box>
    <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} width={'85%'} />
  </VStack>
);

export const loadingItemMobile = (
  <VStack
    marginBottom={Spacing['inset.xs']}
    borderRadius={Spacing['inline.nano']}
    width={'100%'}
    justifyContent={'space-between'}
    paddingX={Spacing['inset.sm']}
    paddingY={Spacing['inset.nano']}
    background={Color['neutral.white']}>
    <HStack alignItems={'center'} py={Spacing['inset.nano']}>
      <Skeleton
        borderRadius={'100%'}
        height={'24px'}
        width={'24px'}
        marginRight={Spacing['inset.nano']}
      />
      <Skeleton borderRadius={Spacing['inline.nano']} height={'24px'} width={'60%'} />
    </HStack>
    <HStack alignItems={'center'} py={Spacing['inset.nano']} justifyContent={'space-between'}>
      <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} width={'26%'} />
      <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} width={'26%'} />
      <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} width={'26%'} />
    </HStack>

    <HStack alignItems={'center'} py={Spacing['inset.nano']} justifyContent={'space-between'}>
      <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} width={'26%'} />
      <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} width={'26%'} />
      <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} width={'26%'} />
    </HStack>
    <HStack alignItems={'center'} py={Spacing['inset.nano']} justifyContent={'space-between'}>
      <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} width={'30%'} />
      <Skeleton borderRadius={Spacing['inline.nano']} height={'18px'} width={'33%'} />
    </HStack>
  </VStack>
);
